import {createGloballyExclusiveHandler} from '../../../../../../shared/scripts/ui_utils/ClientUtils'
import {uiManager} from '../../../../EntryMobile'
import {Sound} from '../../../../../../shared/scripts/Sound'
import {UILobbyController} from '../../../../../../shared/scripts/ui_html/lobby/UILobbyController'
import {RoomStep} from '../../../room/UIMCreateRoomController'
import {SocketLobbySend} from '../../../../../../shared/scripts/socket/SocketLobbySend'
import {ClientUserState} from '../../../../../../shared/scripts/ClientUserState.ts'
import {setElementOnClick} from '../../../../../../shared/scripts/ui_utils/DomUtils.ts'

export class UIMLobbyController extends UILobbyController {
    constructor() {
        super()

        if(this.createRoomButton) {
            setElementOnClick(this.createRoomButton, createGloballyExclusiveHandler(async() => {
                Sound.playSound(Sound.SoundType.JoinRoom)
                await ClientUserState.requireUser()
                uiManager.createRoomController.initCreateRoomView()
            }))
        }

        setElementOnClick(this.joinRoomButton, createGloballyExclusiveHandler(() => {
            this.openJoinRoomPopup()
        }))
    }

    // eslint-disable-next-line class-methods-use-this
    protected override async handleJoinRoom(roomId: string) {
        uiManager.createRoomController.setShowPageOnNextUpdate(RoomStep.RoomPage)
        await SocketLobbySend.accessGameFromLink(roomId)
    }
}
